import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { ImageLeftCTARight as ImageLeftCTARightEditor } from "./image-left-cta-right"
import { ImageLeftCTARightSettings } from "./image-left-cta-right-settings"
import ImageLeftCTARightPreview from "./image-left-cta-right-preview.png"

export const ImageLeftCTARight = {
  name: "ImageLeftCTARight",
  label: "image on left, call to action on right",
  EditorComponent: ImageLeftCTARightEditor,
  SettingsComponent: ImageLeftCTARightSettings,
  image: ImageLeftCTARightPreview,
  defaultProperties: {
    backgroundColor: "#ffffff",
    headingColor: "#000000",
    textColor: "#4d4d4d",
    image: "",
    alt: "",
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    columnRatio: 50,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    gap: 30
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "Here are my best Instagram growth hacks"),
      paragraph(
        "This week I'm sharing some of the tools I use to boost engagement on my posts."
      ),
      button("Read article")
    ])
  ]
}
